import { List, Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const IdentifierDisplayListOfTypeRecord = Record({
  typeId: null,
  idDisplayList: List()
});

const data = {
  collections: {
    idDisplayList: "IdentifierDisplayRecord"
  }
};
createFromJS.registerCallback(
  "IdentifierDisplayListOfTypeRecord",
  createFromJS.createNestedCallback(IdentifierDisplayListOfTypeRecord, data)
);
